import './AccelerateNodeCard.css';
import { cardTitle } from '../../assets/jss/wisene-material-dashboard-pro-react-types';
import { ClassNameMap } from '@material-ui/styles';
import { closeSweetAlertStyle } from '../../helpers/CustomStyles';
import { connect } from 'react-redux';
import { accelerateNode } from '../../stores/actions/nodeActions';
import Button from '../../../components/CustomButtons/ButtonTS';
import CancelIcon from '@material-ui/icons/Cancel';
import Card from '../../../components/Card/CardTS';
import CardHeader from '../../../components/Card/CardHeaderTS';
import CardIcon from '../../../components/Card/CardIcon.js';
import dashboardStyle from '../../assets/jss/views/dashboardStyleTS';
import FastForwardOutlined from '@material-ui/icons/FastForwardOutlined';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import React from 'react';
import styles from '../../assets/jss/views/dashboardStyle';
import { SYSTEM_VERSIONS } from '../../helpers/Systems';
import AccelerateNodeCardBody from './AccelerateNodeCardBody';


const style = {
	cardTitle,
	cardCategory: styles.cardCategory,
};


interface IAccelerateNodeCardProps {
	classes: ClassNameMap;
	hideAlert: () => void;
	nodeID: number;
	nodeName: string;
	systemVersion: string;
	updatedViaWebsiteAt: string;
	acceleratedUntil: string;
	hideAlert: () => void;
}
 
class AccelerateNodeCard extends React.Component<IAccelerateNodeCardProps> {
	render() {
		const { nodeID, nodeName, systemVersion, acceleratedUntil, updatedViaWebsiteAt } = this.props;
        const accelerationModeOn = Date.parse(acceleratedUntil) > Date.now();
        const acceleratedUntilLocal = (new Date(acceleratedUntil)).toLocaleString('sv-SE').replace('T', ' ');
        const headerText = accelerationModeOn
            ? `Accelerated mode ends at: ${acceleratedUntilLocal}.`
            : null;
		// Prevent showing window for W2
		if (systemVersion === SYSTEM_VERSIONS.W2) {
			return <p>Option not available for W2 system version.</p>
		}

		return (
			<ErrorComponent Children message='Error'>
				<GridContainer>
					<GridItem xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Button
							simple
							justIcon
							color='info'
							style={closeSweetAlertStyle}
							onClick={this.props.hideAlert}
							data-testid='cancelButton'
						>
							<CancelIcon style={{ width: '20px', height: '20px' }} />
						</Button>
					</GridItem>
				</GridContainer>

				<Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} data-testid='accelerateCard'>

					<CardHeader color='info' icon>
						<CardIcon color='info'>
							<FastForwardOutlined />
						</CardIcon>
						<p style={{ ...style.cardCategory, textAlign: 'left' }}>{'Accelerate node:'}</p>
						<h3 style={{ ...style.cardTitle, textAlign: 'left', marginLeft: '20%', marginTop: '10px' }}>{nodeName}</h3>
						<p style={{ ...style.cardCategory, textAlign: 'center' }}>{headerText}</p>
					</CardHeader>

					<AccelerateNodeCardBody
					    nodeID={nodeID}
					    updatedViaWebsiteAt={updatedViaWebsiteAt}
						accelerate={this.props.accelerateNode}
						accelerationModeOn={accelerationModeOn}
						acceleratedUntil={acceleratedUntil}
						hideAlert={this.props.hideAlert}
					/>
				</Card>
			</ErrorComponent>
		);
	}
}

const actions = { accelerateNode };
export const ExportCardWithStyles = dashboardStyle(AccelerateNodeCard);
export default connect(null, actions)(ExportCardWithStyles);
